<script>
import Settings from "@/components/rubrics/newRubric/settings.vue";

export default {
  name: "RubricSettingsTab",
  components: {
    Settings,
  },
  props: {
    // Which settings to show
    category: {
      type: Boolean,
      default: false,
    },
    grade: {
      type: Boolean,
      default: true,
    },
    intensity: {
      type: Boolean,
      default: true,
    },
    language: {
      type: Boolean,
      default: true,
    },
  },
  emits: ["changeTemplate"],
};
</script>

<template>
  <div class="rubric-settings-tab">
    <div class="settings-content">
      <Settings
        :title="$t('rubrics.settings')"
        :category="category"
        :grade="grade"
        :language="language"
        :intensity="intensity"
      />
    </div>
  </div>
</template>

<style scoped lang="scss">
.settings-content {
  background: var(--color-surface-neutral-default, #ffffff);
  border-radius: 12px;
  padding: 1.5rem;
  border: 1px solid var(--color-stroke-neutral-subtle, #e5e7eb);

  ::v-deep {
    .eg-form-group:last-child {
      margin-bottom: 0;
    }
  }
}

.settings-actions {
  margin-top: 1.5rem;
  display: flex;
  gap: 0.75rem;
}
</style>
